import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router"

/**
 * Not found component implements the OnInit lifecycle method
 */
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  /**
   * Not found component constructor
   * @param router router module
   * @param route route module
   */
  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  /**
 * Lifecycle hook that is called after data-bound properties of a directive are initialized.
 * 
 * This method is a placeholder and does not contain any implementation.
 */
  ngOnInit() {
  }

  /**
 * Navigates the user to the home page.
 * 
 * Uses the Angular router to navigate to the '/home' route.
 * 
 * Handles successful navigation and potential errors by logging them.
 */
  goHome() {
    this.router.navigate(['/home'], { relativeTo: this.route }).then(nav => {
    }, err => {
      console.log("Error: " + err)
    })
  }
}
